import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BarneyBox } from '@instructure/quiz-common';
import { Heading } from '@instructure/ui-heading';
import { IconEyeSolid } from '@instructure/ui-icons';
import { Button } from '@instructure/ui-buttons';
import t from '@instructure/quiz-i18n/format-message';
export var PreviewFrame = /*#__PURE__*/function (_Component) {
  function PreviewFrame() {
    _classCallCheck(this, PreviewFrame);
    return _callSuper(this, PreviewFrame, arguments);
  }
  _inherits(PreviewFrame, _Component);
  return _createClass(PreviewFrame, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(BarneyBox, {
        screenReaderText: t('You are in preview mode.')
      }, /*#__PURE__*/React.createElement(BarneyBox.Body, null, this.props.children), /*#__PURE__*/React.createElement(BarneyBox.Footer, null, /*#__PURE__*/React.createElement(Heading, {
        level: "h4",
        color: "primary-inverse"
      }, /*#__PURE__*/React.createElement(IconEyeSolid, {
        variant: "icon-inverse"
      }), " \xA0", t('Preview')), /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.onPreviewClose
      }, t('Exit Preview'))));
    }
  }]);
}(Component);
_defineProperty(PreviewFrame, "propTypes", {
  children: PropTypes.element.isRequired,
  onPreviewClose: PropTypes.func.isRequired
});
export default PreviewFrame;